import { Quote, Star } from 'lucide-react';

export default function TestimonialsSection({ testimonials }) {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F4EFE6] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("https://images.unsplash.com/photo-1703245588712-825b1cc9d6dd?w=1200&q=60")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-[#F4EFE6]/90 backdrop-blur-sm" />

      <div className="max-w-7xl mx-auto relative z-10">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-center text-[#292524] mb-4">
          What People Are Saying
        </h2>
        <p className="text-center text-[#78716C] mb-12">
          {testimonials.length}+ practitioners have transformed their lives
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-7 flex flex-col border border-[#E7E5E4] shadow-sm">
              <Quote className="h-7 w-7 text-[#DDA15E] opacity-60 mb-4 shrink-0" />

              <p className="text-[#292524] italic leading-relaxed flex-1 mb-6">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden shrink-0 border-2 border-[#DDA15E]">
                  {t.image_url ? (
                    <img src={t.image_url} alt={t.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full bg-[#9A3B26] flex items-center justify-center">
                      <span className="text-white font-heading font-bold text-lg">
                        {t.name?.charAt(0) || 'A'}
                      </span>
                    </div>
                  )}
                </div>

                <div className="min-w-0">
                  <h4 className="font-heading font-bold text-[#292524] truncate">{t.name}</h4>
                  {(t.age || t.location) && (
                    <p className="text-sm text-[#78716C] truncate">
                      {t.age && `${t.age}`}
                      {t.age && t.location && ', '}
                      {t.location}
                    </p>
                  )}
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(t.rating || 5)].map((_, i) => (
                      <Star key={i} className="h-3.5 w-3.5 fill-[#DDA15E] text-[#DDA15E]" />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
